import Main from '@/layout/main.vue'
import Blank from '@/layout/blank.vue'
const routes = [
    {
        path: '/inventory',
        name: 'inventory',
        meta: { title: '进销存' },
        redirect: '/inventory/index',
        component: Main,
        children: [
            {
                path: '/inventory',
                name: 'inventory_menu',
                meta: {
                    title: '进销存管理',
                    icon: 'icon_caiwu_yue',
                    parentPath: '/inventory',
                    permission: ['view']
                },
                component: Blank,
                redirect: '/inventory/index',
                children: [
                    {
                        path: '/inventory/index',
                        name: 'inventory_index',
                        meta: {
                            title: '进销存概览',
                            parentPath: '/inventory',
                            permission: ['view'],
                            keepAlive: true
                        },
                        component: () => import('@/views/channel/inventory/index.vue')
                    },
                    {
                        path: '/inventory/stock',
                        name: 'inventory_stock',
                        meta: {
                            title: '库存管理',
                            parentPath: '/inventory',
                            permission: ['view'],
                            keepAlive: true
                        },
                        component: () => import('@/views/channel/inventory/stock.vue')
                    },
                    {
                        path: '/inventory/purchase',
                        name: 'inventory_purchase',
                        meta: {
                            title: '进货管理',
                            parentPath: '/inventory',
                            permission: ['view'],
                            keepAlive: true
                        },
                        component: () => import('@/views/channel/inventory/purchase.vue')
                    },
                    {
                        path: '/inventory/sales',
                        name: 'inventory_sales',
                        meta: {
                            title: '销售出库',
                            parentPath: '/inventory',
                            permission: ['view'],
                            keepAlive: true
                        },
                        component: () => import('@/views/channel/inventory/sales.vue')
                    },
                    {
                        path: '/inventory/stocktaking',
                        name: 'inventory_stocktaking',
                        meta: {
                            title: '库存盘点',
                            parentPath: '/inventory',
                            permission: ['view'],
                            keepAlive: true
                        },
                        component: () => import('@/views/channel/inventory/stocktaking.vue')
                    }
                ]
            }
        ]
    }
]
export default routes
